<template>
  <button :type="buttonType" :class="buttonClass" v-on="$listeners" data-pjax="0">
    <span v-show="loading" class="ui centered loader"></span>
    <i :class="icon" v-if="icon"></i>
    {{ $i18n.t(name, { category: 'CommonButton' }) }}
  </button>
</template>

<script>
/**
 * @param CommonButton component
 *
 * @description A listák gombjainak dinamikus megjelenítésére szolgáló component
 */
export default {
  name: 'CommonButton',
  props: {
    buttonStyle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    buttonListType: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClass() {
      let style = this.buttonStyle
      if (this.loading) style += ' transparent'
      if (this.buttonType === 'button') style += ' me-1 mb-1'
      return style
    },
  },
}
</script>

<style lang="scss">
.transparent {
  background: transparent !important;
  color: transparent !important;
  .ui.loader.centered {
    display: block;
  }
}
</style>
